import { put, all, select } from "redux-saga/effects";
import selectors from "rdx/modules/tickets/selectors";
import actions from "rdx/actions";
import getErrorActions from "rdx/utils/getErrorActions";
import postWithRetry from "rdx/utils/postWithRetry";
import { generateIdempotencyKey } from "util/idempotencyKey";
import { keysToCamelCase } from "lib/helpers";
import messages from "../messages";

function* createNewProjectMessage(action) {
  const params = {
    ...action.payload,
  };

  if (!params.channel) params.channel = "conversation";

  const projectId = params.project_id;
  delete params.project_id;

  const idempotencyKey = generateIdempotencyKey();
  const { success, data, error } = yield* postWithRetry(`/projects/${projectId}/messages/`, params, {
    headers: { "Idempotency-Key": idempotencyKey },
  });

  if (success && data) {
    const notices = yield select(selectors.getProjectMessageList);
    const replies = { ...(yield select(selectors.getProjectMessageReplies)) };
    const newNotice = keysToCamelCase(data.body);
    if (!newNotice.channel && params.channel) newNotice.channel = params.channel;
    const newList = [newNotice, ...notices];
    if (newNotice.parentId) {
      replies[newNotice.parentId] = replies[newNotice.parentId]
        ? [newNotice, ...replies[newNotice.parentId]]
        : [newNotice];
      yield put(actions.setProjectMessageReplies({ replies }));
    }
    yield all([
      put(actions.setProjectMessageList({ list: newList })),
      put(
        actions.newSuccessEvent({
          message: messages.CREATE_PROJECT_MESSAGE_SUCCESS,
        }),
      ),
    ]);
  } else {
    return getErrorActions({
      error,
      message: messages.ERROR_CREATING_PROJECT_MESSAGE,
    });
  }
  return null;
}

export default createNewProjectMessage;
